<template lang="pug">
.invoice
    .page
        .page-inner
            .body
                .title Остатки
                .table-order
                    table(
                        v-if="items.length > 0"
                    )
                        thead
                            tr
                                th Наименование
                                th Остатки
                        tbody
                            tr(
                                v-for="item of items"
                            )
                                td {{item.name}}
                                td {{item.weight}} гр
                    div(
                        style="text-align: center;"
                    ) Подождите, считаем остатки...
                        
</template>

<script>
import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
    layout: 'empty',
    data() {
        return {
            items: []
        }
    },
    methods: {
        ...mapMutations('auth', [
            'setLayout'
        ]),
        ...mapActions('storageRemains', [
            'loadMore'
        ])
    },
    created() {
        this.setLayout({
            layout: 'simple-layout'
        })
        this.loadMore({
            limit: null,
            offset: null
        }).then(res => {
            if (res.data.success) {
                this.items = res.data.data
            }
        })
    }
}
</script>

<style lang="scss">
html,body {
    height: auto;
    overflow-y: auto;
}
.invoice {
    margin: 0 auto;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 30px;
    .page-inner {
        // padding: 0 60px;
        width: 185mm;
        margin: 0 auto;
    }
    .head-wrapper {
        border-bottom: 2px solid #e1e1e1;
        margin-bottom: 40px;
    }
    .head {
        overflow: hidden;
        margin: 0 0 10mm;
        width: 100%;
    }
    .body {
        .title {
            text-align: center;
            font-size: 18px;
            font-weight: 600;
        }
        .date {
            font-size: 14px;
            text-align: center;
            font-weight: 600;
            margin-top: 3px;
            margin-bottom: 40px;
        }
        .table-client {
            table {
                width: 100%;
                td {
                    padding: 5px 0;
                    padding-right: 5mm;
                    font-size: 12px;
                    &:nth-child(4) {
                        padding-right: 0;
                        padding-left: 5mm;
                    }
                }
            }
        }
    }
    .table-order {
        padding-top: 30px;
        .center {
            text-align: center !important;
        }
        .right {
            text-align: right !important;
        }
        table {
            width: 100%;
            thead {
                th {
                    border: 2px solid #f0f0f0;
                    padding: 8px 15px;
                    text-align: left;
                    // width: 50px;
                    font-size: 12px;
                    color: #6f6f6f;
                    background: #f0f0f0;
                    font-weight: 300;
                    // &.full {
                    //     width: 100%;
                    // }
                }
            }
            tbody {
                tr {

                }
                td {
                    border: 2px solid #f0f0f0;
                    padding: 10px 15px;
                    font-size: 14px;
                }
            }
        }
    }
    .bottom-desc {
        font-size: 18px;
        text-align: center;
        font-weight: 600;
        margin-top: 40px;
    }
    .inner-table {
        th {
            font-size: 12px;
            font-weight: 300;
            padding-bottom: 5px;
            text-align: left;
            padding-left: 10mm;
        }
        td {
            font-size: 14px;
            font-weight: 600;
            padding-left: 10mm;
        }
    }
    @page {
        size: A4;
        margin: 0;
    }
    @media print {
        html, body {
            width: 210mm;
            height: 297mm;        
        }
        .page {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            min-height: initial;
            box-shadow: initial;
            background: initial;
            page-break-after: always;
        }
    }
}
</style>
